import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getThemeSetting } from './getThemeSetting';
import { loadTheme } from './loadTheme';
import { monitorSystemThemeChanges } from './monitorSystemThemeChanges';
import { ThemeMode } from '../schema/ThemeMode';
import type { ThemeId } from '../schema/ThemeId';

/**
 * Load the theme and set the css variables on the document
 */
export const initializeThemeStore = (themeId?: ThemeId, themeMode?: ThemeMode): void => {
    const effectiveThemeMode = (themeMode ??
        getUserConfiguration()?.UserOptions?.MiniDarkMode ??
        ThemeMode.System) as number;
    const effectiveThemeId = (themeId ?? getThemeSetting()) as ThemeId;
    loadTheme(effectiveThemeId, effectiveThemeMode);
    monitorSystemThemeChanges();
};
